export default __webpack_public_path__ + "static/media/blankUser.a9136072.png";